/**
 * お気に入り関連のQuery Hooks
 * TanStack Queryを使用したデータフェッチングとキャッシュ管理
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getFavoriteAccountIds } from '@/lib/api/accounts';
import { favoriteKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * お気に入りアカウントID一覧を取得するQuery Hook
 */
export function useFavoriteAccountIds() {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: favoriteKeys.accountIds(),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getFavoriteAccountIds(authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized, // 認証状態が準備完了してから実行
    staleTime: CACHE_TIME.FAVORITES,
  });
}
